import { render, staticRenderFns } from "./pro_derecha.vue?vue&type=template&id=6376b36a&"
import script from "./pro_derecha.vue?vue&type=script&lang=js&"
export * from "./pro_derecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports